// Index files are intended for importing and executing functions and classes only. They should not contain any logic.
import showSingleYAML from './showSingleYAML.js';
import { initToggleBlocks } from './show-more-info.js';
import './giftcard-balance-check.js';
import checkCardsAvailability from '../collection/checkCardsAvailability.js';
import notifyMe from '../product/notifyMe.js';

function index() {
  showSingleYAML();
  initToggleBlocks();
  notifyMe(); // Initialize notifyMe globally so it's available for product cards
  checkCardsAvailability();
}

export default index;
